import Vue from 'vue';
import VueI18n from 'vue-i18n';
import elementZh from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';

Vue.use(VueI18n);

const appMessages = {
  zh: {
    app: {
      title: '工单系统'
    },
    common: {
      login: '登录',
      logout: '退出',
      confirm: '确认',
      cancel: '取消',
      submit: '提交',
      loading: '加载中...',
      refresh: '刷新',
      search: '\u641c\u7d22',
      back: '返回',
      new: '新建',
      actions: '操作',
      view: '查看',
      show: '显示',
      hide: '隐藏',
      requiredTag: '必填',
      upload: '上传',
      uploading: '正在上传...',
      uploadFailed: '上传失败',
      uploadTip: '文件通过 /api/files 存储（若存在 ffmpeg，视频将自动转码）。',
      pasteHint: '将图片按 Ctrl+V 粘贴至此处',
      pasteHintSub: '支持图片/视频/附件上传（也可点击上传选择文件）',
      uploadLimit: '大小限制：单次上传最大 {max}',
      uploadTooLarge: '文件过大：单次上传最大 {max}',
      download: '下载',
      uploaded: '已上传',
      attachmentUnavailable: '附件不可访问或已失效',
      language: '语言',
      zh: '中文',
      en: '英文',
      required: '必填',
      selectAll: '全选',
      invert: '反选',
      clear: '清空',
      edit: '编辑',
      delete: '删除'
    },
    auth: {
      username: '账号',
      password: '密码',
      changePassword: '修改密码',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmNewPassword: '确认新密码',
      passwordStrength: '密码强度',
      strengthWeak: '弱',
      strengthMedium: '中',
      strengthStrong: '强',
      passwordSameAsOld: '新密码不能与旧密码相同',
      passwordMismatch: '两次输入的密码不一致',
      passwordUpdated: '密码已更新',
      captcha: '验证码',
      captchaRefresh: '换一张',
      subtitle: 'JWT + 图形验证码',
      sessionExpired: '登录已过期',
      pleaseLoginAgain: '您的登录已过期，请重新登录'
    },
    menu: {
      dashboard: '概览',
      tickets: '工单',
      tasks: '任务单',
      announcements: '公告',
      kpi: 'KPI 仪表盘',
      handlerPool: '公共池',
      handlerInProgress: '处理中',
      handlerClosed: '\u5b8c\u7ed3\u5de5\u5355',
      handlerDisputes: '争议池',
      secondarySubmit: '提交工单',
      secondaryPending: '二级工单',
      secondaryReturned: '退回工单',
      secondaryClosed: '完结工单',
      secondaryDisputes: '二级争议',
      adminUsers: '账号管理',
      adminTasks: '任务管理',
      adminAnnouncements: '公告管理',
      adminSystem: '系统管理'
    },
    announcement: {
      blockTip: '未确认公告将阻断所有操作（仅允许查看/确认公告）。',
      queue: '确认队列',
      allConfirmed: '已全部确认',
      allConfirmedHint: '当前没有待确认公告，可以返回概览或查看历史公告。',
      required: '必确认',
      confirmed: '已确认',
      history: '历史公告',
      historyTitle: '公告历史',
      historyHint: '查看已发布给你的公告和确认状态。',
      empty: '暂无公告'
    },
    dashboard: {
      profile: '账户信息',
      notifications: '通知设置',
      enableNotifications: '开启通知',
      notificationsEnabled: '已开启',
      notificationsBlocked: '已被阻止',
      notificationsGranted: '✅ 通知权限已授予',
      notificationsDenied: '🚫 通知权限被阻止（请在浏览器设置中允许）',
      notificationsDefault: '点击按钮请求通知权限',
      notificationsNotSupported: '当前浏览器不支持通知功能',
      ticketsHint: '创建 / 补充 / 争议',
      tasksHint: '红点：未提交回执的任务',
      handlerHint: '接管 / 回复 / 退回 / 结案',
      announcementsRequiredHint: '有公告需要先确认',
      announcementsHistoryHint: '查看历史公告与确认状态',
      handlerPoolHint: '待接管的公共工单',
      handlerInProgressHint: '查看正在处理的工单',
      handlerDisputesHint: '待接管的争议处理',
      secondaryPendingHint: '二级链路工单及上报后的处理状态',
      secondaryReturnedHint: '被你退回补充的工单',
      secondaryClosedHint: '查看处理完成的二级链路工单和自己提交的工单',
      secondarySubmitHint: '二级处理员提交的工单将直接进入处理员公共池',
      secondaryDisputesHint: '经过二级处理链路的完结争议先由原二级处理员接收',
      secondaryFollowTitle: '退回 / 结果',
      secondaryFollowHint: '处理被退回的工单，或查看已提交工单的结果',
      secondaryDeskTitle: '任务 / 公告',
      secondaryDeskHint: '处理任务回执与公告确认',
      secondaryTasksHint: '二级处理员回执任务',
      secondaryAnnouncementsRequiredHint: '有公告需要先确认',
      secondaryAnnouncementsHistoryHint: '查看公告历史与确认状态',
      adminUsersHint: '创建、禁用、解锁账号',
      adminTasksHint: '发布任务并查看回执',
      adminAnnouncementsHint: '发布公告并查看确认',
      adminSystemHint: '清理、存储与系统操作',
      active: '进行中',
      manage: '管理',
      report: '报表',
      system: '系统',
      kpiHint: '近 7 天默认周期',
      realtime: '实时推送',
      realtimeHint: 'SSE：/api/stream（禁止轮询）'
    },
    notification: {
      banner: '开启桌面通知后，即使浏览器最小化也能收到工单提醒',
      enable: '开启通知',
      dismiss: '暂不开启'
    },
    field: {
      type: '\u7c7b\u578b',
      caseNo: '工单号',
      title: '标题',
      description: '描述',
      message: '内容',
      attachments: '附件',
      status: '状态',
      timeout: '超时',
      createdAt: '创建时间',
      takenAt: '接管时间',
      closedAt: '\u5b8c\u7ed3\u65f6\u95f4'
    },
    ticket: {
      newTicket: '新建工单',
      ticketNo: '工单',
      timeline: '时间线',
      actions: '操作区',
      searchPlaceholder: '标题 / 工单号',
      stats: {
        total: '工单总数',
        pending: '待接管工单数',
        inProgress: '处理中工单数',
        waitingResubmit: '待补充工单数',
        closed: '已完结工单数',
        canceled: '已取消工单数'
      },
      resubmit: '补充并重新提交',
      cancelTicket: '取消工单',
      createDispute: '提交争议',
      urge: '催单',
      urgeDispute: '催争议单',
      urgeSent: '已发出催单提醒',
      reminded: '有催单或超时提醒',
      submittedToPool: '已提交到处理员公共池',
      submitTarget: '提交去向',
      targetPool: '处理员公共池',
      targetPoolHint: '普通处理员接管并处理该工单。',
      targetSecondary: '指定二级处理员',
      targetSecondaryHint: '工单先到指定二级处理员，由其处理、退回或上报给处理员公共池。',
      secondaryHandler: '二级处理员',
      selectSecondaryHandler: '请选择二级处理员',
      requiredSecondaryHandler: '请选择二级处理员',
      disputeLabel: '争议',
      requiredContent: '请填写内容',
      requiredTitle: '请填写标题'
    },
    task: {
      receipt: '回执',
      confirmBeforeSubmit: '请先确认接收',
      requiredContent: '请填写回执内容'
    },
    dispute: {
      result: {
        RESOLVED: '\u901a\u8fc7',
        REJECTED: '\u9a73\u56de',
        OK: '\u901a\u8fc7',
        REJECT: '\u9a73\u56de',
        PARTIAL: '\u90e8\u5206\u901a\u8fc7'
      }
    },
    secondary: {
      assignedCases: '用户工单',
      escalatedReturnedCases: '上报退回',
      disputeCases: '争议工单',
      resubmitToHandler: '补充并重新提交'
    },
    admin: {
      create: '创建',
      username: '账号',
      displayName: '姓名',
      role: '角色',
      password: '密码',
      resetPassword: '重置密码',
      kickOffline: '踢下线',
      kickOfflineConfirm: '确定要踢下线该账号吗？该用户需要重新登录。',
      locked: "\u9501\u5b9a",
      unlock: "\u89e3\u9501",
      unlockConfirm: "\u786e\u5b9a\u8981\u89e3\u9501\u8be5\u8d26\u53f7\u5417\uff1f",
      assignUsers: '指派用户',
      viewReceipts: '查看回执',
      recipients: '接收用户',
      viewConfirmations: '查看确认情况',
      confirmed: '已确认',
      unconfirmed: '未确认',
      enabled: '启用',
      disabled: '禁用',
      softDelete: '软删除',
      deleted: '已删除',
      softDeleteHint: '软删除不会清除历史数据，但会禁止登录并默认从列表隐藏。',
      systemManagement: '系统管理',
      dataLifecycle: '数据生命周期',
      purgeAllData: '数据清空',
      purgeWarning: '⚠️ 此操作将删除所有业务数据（工单、任务、公告等），但保留用户账号。操作不可逆，请谨慎使用。',
      confirmPhrase: '确认短语',
      confirmPhraseHint: '请输入 "DELETE ALL DATA" 以确认',
      adminPassword: '管理员密码',
      startPurge: '发起清空',
      purgeInProgress: '清空中...',
      purgeCompleted: '清空完成',
      purgeFailed: '清空失败',
      confirmPhraseError: '确认短语不正确',
      passwordRequired: '请输入管理员密码',
      purgeJobStatus: '任务状态',
      purgeDeleting: '正在删除数据，请稍候...',
      purgeDeletedRecords: '已删除：{count} 条记录',
      purgeStartTime: '开始时间',
      purgeEndTime: '完成时间',
      purgeError: '错误',
      purgeStarted: '清空任务已启动',
      purgeStartFailed: '发起清空失败',
      purgeCompletedMsg: '清空完成，共删除 {count} 条记录',
      statusInProgress: '进行中',
      statusCompleted: '已完成',
      statusFailed: '失败',
      teams: '团队',
      team: '团队',
      teamName: '团队名称',
      teamMembers: '团队成员',
      createTeam: '创建团队',
      editTeam: '编辑团队',
      deleteTeamConfirm: '删除团队后成员将不再共享工单，确定删除吗？',
      caseNoPrefix: '工单前缀',
      setCaseNoPrefix: '设置工单前缀',
      caseNoPrefixPlaceholder: '例如 LZ / GZ',
      caseNoPrefixHint: '仅对二级处理员生效，留空则指定到该二级处理员的新工单继续使用旧工单号格式。',
      closeTask: '关闭任务',
      closeTaskConfirm: '关闭后接收人将不能再提交回执，确定关闭该任务吗？',
      taskActive: '进行中',
      taskClosed: '已关闭'
    },
    handler: {
      take: '接管',
      release: '释放回公共池',
      disputeRelease: '\u91ca\u653e\u4e89\u8bae',
      replyReturn: '回复并退回',
      replyEscalate: '回复并上报',
      replyClose: '回复并完结',
      disputeEscalate: '上报争议',
      disputeClose: '\u56de\u590d\u5e76\u5b8c\u7ed3(\u4e89\u8bae)',
      caseNo: '工单',
      timeout30: '30分钟+',
      timeout24: '24小时+',
      batchRelease: '一键释放全部',
      batchReleaseConfirm: '确定要释放所有处理中的工单回公共池吗？'
    },
    kpi: {
      apply: '应用',
      trend: '趋势',
      created: '工单创建量',
      taken: '接管量',
      closed: '完结量',
      returned: '退回次数',
      disputeRate: '争议率',
      avgFirstResponse: '首次响应均值（分钟）',
      avgClose: '平均完结耗时（分钟）',
      avgDispute: '平均争议处理（分钟）',
      from: '开始日期',
      to: '结束日期',
      timezoneShanghai: '北京时间',
      timezoneUtc: 'UTC',
      granularity: '趋势粒度',
      granularityDay: '按天',
      granularityWeek: '按周',
      granularityMonth: '按月',
      granularityQuarter: '按季度',
      ticketTrend: '工单趋势',
      efficiencyTrend: '处理效率',
      caseAudit: '工单审计',
      caseAuditHint: '管理员只读查看所有工单内容和附件',
      caseSearchPlaceholder: '工单号 / 标题',
      requester: '用户',
      handler: '处理员',
      disputeFilter: '争议',
      disputeNone: '无争议',
      disputeHas: '有争议',
      disputeNoneShort: '无',
      disputeActiveShort: '争议中',
      disputeStatus: '争议状态',
      disputeResult: '争议结果',
      processingStats: '处理统计',
      disputeStats: '争议统计',
      count: '数量',
      handlerTaken: '处理员接管工单',
      handlerClosed: '处理员完结工单',
      handlerReturned: '处理员退回工单',
      secondaryReceived: '二级接收工单',
      secondaryEscalated: '二级上报工单',
      secondaryClosed: '二级完结工单',
      secondaryReturned: '二级退回用户',
      disputeCreated: '争议创建',
      disputeTaken: '争议接管',
      disputeClosed: '争议完结',
      disputeResolved: '通过',
      disputeRejected: '驳回'
    },
    role: {
      USER: '用户',
      HANDLER: '处理员',
      SECONDARY_HANDLER: '二级处理员',
      ADMIN: '管理员',
      me: '我',
      handler: '处理员',
      system: '系统'
    },
    status: {
      ticket: {
        PENDING: '待接管',
        IN_PROGRESS: '处理中',
        PENDING_SECONDARY: '处理中',
        ESCALATED: '已上报',
        ESCALATED_RETURNED: '上报退回',
        WAITING_RESUBMIT: '待补充',
        CLOSED: '已完结',
        CANCELED: '已取消'
      },
      task: {
        UNREAD: '未查看',
        READ: '已查看',
        CONFIRMED: '已确认',
        SUBMITTED: '已提交'
      },
      dispute: {
        DISPUTE_CREATED: '已提交',
        DISPUTE_SECONDARY_CREATED: '待处理',
        DISPUTE_SECONDARY_IN_PROGRESS: '处理中',
        DISPUTE_IN_PROGRESS: '处理中',
        DISPUTE_CLOSED: '已结案'
      }
    },
    phase: {
      CASE: '工单',
      DISPUTE: '争议'
    },
    event: {
      CASE_CREATED: '新工单',
      CASE_RESUBMITTED: '补充提交',
      CASE_TAKEN: '已接管',
      CASE_RELEASED: '已释放',
      CASE_RETURNED: '已退回',
      CASE_ASSIGNED: '已指派二级',
      CASE_ESCALATED: '已上报二级',
      CASE_ESCALATED_RETURNED: '上报退回',
      CASE_CLOSED: '已完结',
      CASE_CANCELED: '已取消',
      CASE_URGED: '工单已被催办',
      FIRST_RESPONSE_TIMEOUT: '首次响应超时',
      CLOSE_TIMEOUT: '处理完结超时',
      DISPUTE_CREATED: '争议已提交',
      DISPUTE_SECONDARY_CREATED: '二级争议已提交',
      DISPUTE_SECONDARY_TAKEN: '二级争议已接收',
      DISPUTE_SECONDARY_ESCALATED: '二级争议已上报',
      DISPUTE_TAKEN: '争议已接管',
      DISPUTE_URGED: '争议单已被催办',
      DISPUTE_TIMEOUT: '争议单处理超时',
      DISPUTE_CLOSED: '争议已结案',
      TASK_ASSIGNED: '任务指派',
      TASK_CLOSED: '任务已关闭',
      ANNOUNCEMENT_CREATED: '公告发布',
      ANNOUNCEMENT_CONFIRMED: '公告确认',
      TASK_RECEIPT_SUBMITTED: '任务回执提交'
    }
  },
  en: {
    app: {
      title: 'Ticket System'
    },
    common: {
      login: 'Login',
      logout: 'Logout',
      confirm: 'Confirm',
      cancel: 'Cancel',
      submit: 'Submit',
      loading: 'Loading...',
      refresh: 'Refresh',
      search: 'Search',
      back: 'Back',
      new: 'New',
      actions: 'Actions',
      view: 'View',
      show: 'Show',
      hide: 'Hide',
      requiredTag: 'Required',
      upload: 'Upload',
      uploading: 'Uploading...',
      uploadFailed: 'Upload failed',
      uploadTip: 'Files are stored via /api/files (video auto-transcode if ffmpeg exists).',
      pasteHint: 'Paste image here with Ctrl+V',
      pasteHintSub: 'Supports images, videos, and files (or click Upload to choose)',
      uploadLimit: 'Size limit: max {max} per upload',
      uploadTooLarge: 'File too large: max {max} per upload',
      download: 'Download',
      uploaded: 'Uploaded',
      attachmentUnavailable: 'Attachment unavailable',
      language: 'Language',
      zh: 'Chinese',
      en: 'English',
      required: 'Required',
      selectAll: 'Select all',
      invert: 'Invert',
      clear: 'Clear',
      edit: 'Edit',
      delete: 'Delete'
    },
    auth: {
      username: 'Username',
      password: 'Password',
      changePassword: 'Change password',
      oldPassword: 'Old password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      passwordStrength: 'Password strength',
      strengthWeak: 'Weak',
      strengthMedium: 'Medium',
      strengthStrong: 'Strong',
      passwordSameAsOld: 'New password must be different',
      passwordMismatch: 'Passwords do not match',
      passwordUpdated: 'Password updated',
      captcha: 'Captcha',
      captchaRefresh: 'Refresh',
      subtitle: 'JWT + Captcha',
      sessionExpired: 'Session Expired',
      pleaseLoginAgain: 'Your session has expired. Please login again.'
    },
    menu: {
      dashboard: 'Overview',
      tickets: 'Tickets',
      tasks: 'Tasks',
      announcements: 'Announcements',
      kpi: 'KPI Dashboard',
      handlerPool: 'Pool',
      handlerInProgress: 'In Progress',
      handlerClosed: 'Closed',
      handlerDisputes: 'Disputes',
      secondarySubmit: 'Submit Case',
      secondaryPending: 'Secondary Cases',
      secondaryReturned: 'Returned Cases',
      secondaryClosed: 'Closed Cases',
      secondaryDisputes: 'Secondary Disputes',
      adminUsers: 'Users',
      adminTasks: 'Tasks',
      adminAnnouncements: 'Announcements',
      adminSystem: 'System'
    },
    announcement: {
      blockTip: 'Unconfirmed announcements will block all operations (only view/confirm is allowed).',
      queue: 'Queue',
      allConfirmed: 'All confirmed',
      allConfirmedHint: 'There are no announcements waiting for confirmation. Return to overview or review history.',
      required: 'Required',
      confirmed: 'Confirmed',
      history: 'History',
      historyTitle: 'Announcement History',
      historyHint: 'Review announcements published to you and their confirmation state.',
      empty: 'No announcements'
    },
    dashboard: {
      profile: 'Profile',
      notifications: 'Notification Settings',
      enableNotifications: 'Enable Notifications',
      notificationsEnabled: 'Enabled',
      notificationsBlocked: 'Blocked',
      notificationsGranted: '✅ Notification permission granted',
      notificationsDenied: '🚫 Notification permission denied (please allow in browser settings)',
      notificationsDefault: 'Click button to request notification permission',
      notificationsNotSupported: 'Notifications are not supported in this browser',
      ticketsHint: 'Create / Resubmit / Dispute',
      tasksHint: 'Red dot: tasks not submitted',
      handlerHint: 'Take / Reply / Return / Close',
      announcementsRequiredHint: 'Confirmation required before continuing',
      announcementsHistoryHint: 'Review announcement history and status',
      handlerPoolHint: 'Cases waiting in the public pool',
      handlerInProgressHint: 'Review cases currently in progress',
      handlerDisputesHint: 'Disputes waiting for handling',
      secondaryPendingHint: 'Secondary-routed cases and escalated handling status',
      secondaryReturnedHint: 'Cases returned to secondary handling',
      secondaryClosedHint: 'Review closed secondary-routed and submitted cases',
      secondarySubmitHint: 'Cases submitted by secondary handlers go directly to the handler pool',
      secondaryDisputesHint: 'Disputes from secondary-routed cases return to the original secondary handler first',
      secondaryFollowTitle: 'Returned / Results',
      secondaryFollowHint: 'Handle returned cases or review results for cases you submitted',
      secondaryDeskTitle: 'Tasks / Announcements',
      secondaryDeskHint: 'Handle task receipts and announcement confirmations',
      secondaryTasksHint: 'Receipt tasks for secondary handlers',
      secondaryAnnouncementsRequiredHint: 'Confirmation required before continuing',
      secondaryAnnouncementsHistoryHint: 'Review announcement history and confirmation status',
      adminUsersHint: 'Create, disable, and unlock accounts',
      adminTasksHint: 'Publish tasks and review receipts',
      adminAnnouncementsHint: 'Publish announcements and track confirmations',
      adminSystemHint: 'Cleanup, storage, and system actions',
      active: 'Active',
      manage: 'Manage',
      report: 'Report',
      system: 'System',
      kpiHint: 'Default: last 7 days',
      realtime: 'Realtime',
      realtimeHint: 'SSE: /api/stream (no polling)'
    },
    notification: {
      banner: 'Enable desktop notifications to receive alerts even when the browser is minimized',
      enable: 'Enable',
      dismiss: 'Not now'
    },
    field: {
      type: 'Type',
      caseNo: 'Case No',
      title: 'Title',
      description: 'Description',
      message: 'Message',
      attachments: 'Attachments',
      status: 'Status',
      timeout: 'Timeout',
      createdAt: 'Created',
      takenAt: 'Taken',
      closedAt: 'Closed at'
    },
    ticket: {
      newTicket: 'New Ticket',
      ticketNo: 'Ticket',
      timeline: 'Timeline',
      actions: 'Actions',
      searchPlaceholder: 'Title / Case No',
      stats: {
        total: 'Total',
        pending: 'Pending',
        inProgress: 'In progress',
        waitingResubmit: 'Waiting resubmit',
        closed: 'Closed',
        canceled: 'Canceled'
      },
      resubmit: 'Resubmit',
      cancelTicket: 'Cancel Ticket',
      createDispute: 'Create Dispute',
      urge: 'Urge',
      urgeDispute: 'Urge dispute',
      urgeSent: 'Reminder sent',
      reminded: 'Reminder pending',
      submittedToPool: 'Submitted to handler pool',
      submitTarget: 'Submit target',
      targetPool: 'Handler pool',
      targetPoolHint: 'A regular handler will take and process this case.',
      targetSecondary: 'Specific secondary handler',
      targetSecondaryHint: 'The case goes to a selected secondary handler first, who can handle, return, or escalate it.',
      secondaryHandler: 'Secondary handler',
      selectSecondaryHandler: 'Select secondary handler',
      requiredSecondaryHandler: 'Select a secondary handler',
      disputeLabel: 'Dispute',
      requiredContent: 'Content required',
      requiredTitle: 'Title required'
    },
    task: {
      receipt: 'Receipt',
      confirmBeforeSubmit: 'Confirm required',
      requiredContent: 'Content required'
    },
    dispute: {
      result: {
        RESOLVED: 'Resolved',
        REJECTED: 'Rejected',
        OK: 'OK',
        REJECT: 'Reject',
        PARTIAL: 'Partial'
      }
    },
    secondary: {
      assignedCases: 'User cases',
      escalatedReturnedCases: 'Returned escalations',
      disputeCases: 'Disputes',
      resubmitToHandler: 'Resubmit'
    },
    admin: {
      create: 'Create',
      username: 'Username',
      displayName: 'Display name',
      role: 'Role',
      password: 'Password',
      resetPassword: 'Reset password',
      kickOffline: 'Kick offline',
      kickOfflineConfirm: 'Force logout this account? The user will need to login again.',
      locked: "Locked",
      unlock: "Unlock",
      unlockConfirm: "Unlock this account?",
      assignUsers: 'Assign users',
      viewReceipts: 'View receipts',
      recipients: 'Recipients',
      viewConfirmations: 'View confirmations',
      confirmed: 'Confirmed',
      unconfirmed: 'Unconfirmed',
      enabled: 'Enabled',
      disabled: 'Disabled',
      softDelete: 'Soft delete',
      deleted: 'Deleted',
      softDeleteHint: 'Soft delete keeps historical data but blocks login and hides the account by default.',
      systemManagement: 'System Management',
      dataLifecycle: 'Data Lifecycle',
      purgeAllData: 'Purge All Data',
      purgeWarning: 'This operation will delete all tickets, tasks, announcements, notifications, etc., keeping only user accounts. This action is irreversible!',
      confirmPhrase: 'Confirmation Phrase',
      confirmPhraseHint: 'Type "DELETE ALL DATA" to confirm',
      adminPassword: 'Admin Password',
      startPurge: 'Start Purge',
      purgeInProgress: 'Purge in progress...',
      purgeCompleted: 'Purge completed',
      purgeFailed: 'Purge failed',
      confirmPhraseError: 'Confirmation phrase is incorrect',
      passwordRequired: 'Admin password required',
      purgeJobStatus: 'Job Status',
      purgeDeleting: 'Deleting data, please wait...',
      purgeDeletedRecords: 'Deleted: {count} records',
      purgeStartTime: 'Start time',
      purgeEndTime: 'End time',
      purgeError: 'Error',
      purgeStarted: 'Purge job started',
      purgeStartFailed: 'Failed to start purge',
      purgeCompletedMsg: 'Purge completed, {count} records deleted',
      statusInProgress: 'In Progress',
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      teams: 'Teams',
      team: 'Team',
      teamName: 'Team name',
      teamMembers: 'Team members',
      createTeam: 'Create team',
      editTeam: 'Edit team',
      deleteTeamConfirm: 'Deleting the team stops shared ticket visibility for its members. Continue?',
      caseNoPrefix: 'Case prefix',
      setCaseNoPrefix: 'Set case prefix',
      caseNoPrefixPlaceholder: 'e.g. LZ / GZ',
      caseNoPrefixHint: 'Only applies to secondary handlers. Leave empty to keep the old case number format for new cases routed to this secondary handler.',
      closeTask: 'Close task',
      closeTaskConfirm: 'Recipients cannot submit receipts after close. Close this task?',
      taskActive: 'Active',
      taskClosed: 'Closed'
    },
    handler: {
      take: 'Take',
      release: 'Release to pool',
      disputeRelease: 'Release dispute',
      replyReturn: 'Reply + Return',
      replyEscalate: 'Reply + Escalate',
      replyClose: 'Reply + Close',
      disputeEscalate: 'Escalate dispute',
      disputeClose: 'Close dispute',
      caseNo: 'Case',
      timeout30: '30m+',
      timeout24: '24h+',
      batchRelease: 'Release all',
      batchReleaseConfirm: 'Release all in-progress cases back to pool?'
    },
    kpi: {
      apply: 'Apply',
      trend: 'Trend',
      created: 'Created',
      taken: 'Taken',
      closed: 'Closed',
      returned: 'Returned',
      disputeRate: 'Dispute rate',
      avgFirstResponse: 'Avg first response (min)',
      avgClose: 'Avg close (min)',
      avgDispute: 'Avg dispute handling (min)',
      from: 'From',
      to: 'To',
      timezoneShanghai: 'Beijing time',
      timezoneUtc: 'UTC',
      granularity: 'Granularity',
      granularityDay: 'Daily',
      granularityWeek: 'Weekly',
      granularityMonth: 'Monthly',
      granularityQuarter: 'Quarterly',
      ticketTrend: 'Case trend',
      efficiencyTrend: 'Efficiency',
      caseAudit: 'Case Audit',
      caseAuditHint: 'Admin read-only access to all case content and attachments',
      caseSearchPlaceholder: 'Case No / Title',
      requester: 'User',
      handler: 'Handler',
      disputeFilter: 'Dispute',
      disputeNone: 'No dispute',
      disputeHas: 'Has dispute',
      disputeNoneShort: 'None',
      disputeActiveShort: 'Active',
      disputeStatus: 'Dispute status',
      disputeResult: 'Dispute result',
      processingStats: 'Processing Stats',
      disputeStats: 'Dispute Stats',
      count: 'Count',
      handlerTaken: 'Handler taken cases',
      handlerClosed: 'Handler closed cases',
      handlerReturned: 'Handler returned cases',
      secondaryReceived: 'Secondary received cases',
      secondaryEscalated: 'Secondary escalated cases',
      secondaryClosed: 'Secondary closed cases',
      secondaryReturned: 'Secondary returned cases',
      disputeCreated: 'Disputes created',
      disputeTaken: 'Disputes taken',
      disputeClosed: 'Disputes closed',
      disputeResolved: 'Resolved',
      disputeRejected: 'Rejected'
    },
    role: {
      USER: 'User',
      HANDLER: 'Handler',
      SECONDARY_HANDLER: 'Secondary Handler',
      ADMIN: 'Admin',
      me: 'Me',
      handler: 'Handler',
      system: 'System'
    },
    status: {
      ticket: {
        PENDING: 'Pending',
        IN_PROGRESS: 'In progress',
        PENDING_SECONDARY: 'In progress',
        ESCALATED: 'Escalated',
        ESCALATED_RETURNED: 'Returned escalation',
        WAITING_RESUBMIT: 'Waiting resubmit',
        CLOSED: 'Closed',
        CANCELED: 'Canceled'
      },
      task: {
        UNREAD: 'Unread',
        READ: 'Read',
        CONFIRMED: 'Confirmed',
        SUBMITTED: 'Submitted'
      },
      dispute: {
        DISPUTE_CREATED: 'Created',
        DISPUTE_SECONDARY_CREATED: 'Pending',
        DISPUTE_SECONDARY_IN_PROGRESS: 'In progress',
        DISPUTE_IN_PROGRESS: 'In progress',
        DISPUTE_CLOSED: 'Closed'
      }
    },
    phase: {
      CASE: 'Case',
      DISPUTE: 'Dispute'
    },
    event: {
      CASE_CREATED: 'Case created',
      CASE_RESUBMITTED: 'Case resubmitted',
      CASE_TAKEN: 'Case taken',
      CASE_RELEASED: 'Case released',
      CASE_RETURNED: 'Case returned',
      CASE_ASSIGNED: 'Assigned to secondary',
      CASE_ESCALATED: 'Escalated',
      CASE_ESCALATED_RETURNED: 'Returned escalation',
      CASE_CLOSED: 'Case closed',
      CASE_CANCELED: 'Case canceled',
      CASE_URGED: 'Case urged',
      FIRST_RESPONSE_TIMEOUT: 'First response timeout',
      CLOSE_TIMEOUT: 'Close timeout',
      DISPUTE_CREATED: 'Dispute created',
      DISPUTE_SECONDARY_CREATED: 'Secondary dispute created',
      DISPUTE_SECONDARY_TAKEN: 'Secondary dispute taken',
      DISPUTE_SECONDARY_ESCALATED: 'Secondary dispute escalated',
      DISPUTE_TAKEN: 'Dispute taken',
      DISPUTE_URGED: 'Dispute urged',
      DISPUTE_TIMEOUT: 'Dispute timeout',
      DISPUTE_CLOSED: 'Dispute closed',
      TASK_ASSIGNED: 'Task assigned',
      TASK_CLOSED: 'Task closed',
      ANNOUNCEMENT_CREATED: 'Announcement created',
      ANNOUNCEMENT_CONFIRMED: 'Announcement confirmed',
      TASK_RECEIPT_SUBMITTED: 'Task receipt submitted'
    }
  }
};

const messages = {
  zh: { ...elementZh, ...appMessages.zh },
  en: { ...elementEn, ...appMessages.en }
};

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  fallbackLocale: 'zh',
  messages
});

export default i18n;
